import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_DOCUMENT_TEMPLATES } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const documentTemplates = {
  namespaced: true,
  state: buildInitialState({
    documentTemplateList: []
  }),
  getters: {
    getField
  },
  actions: {
    getDocumentTemplates ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Loading templates, please wait...' })

      return api.doGet({ path: PATH_DOCUMENT_TEMPLATES, parameters: filters })
        .then(json => json.data)
        .then(templates => {
          commit('updateStatus', { status: COMPLETE })
          commit('setDocumentTemplates', templates)
          return templates
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load templates')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    // Does not commit to documentTemplateList, so it won't fight DocumentTemplateList.vue
    // over shared list state when both are mounted at the same time.
    getActiveDocumentTemplateOptions ({ dispatch }, filters = {}) {
      return api.doGet({ path: PATH_DOCUMENT_TEMPLATES, parameters: filters })
        .then(json => json.data || [])
        .catch(() => {
          notifyError(dispatch, 'Unable to load document templates')
          return []
        })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setDocumentTemplates (state, templates) {
      state.documentTemplateList = templates
    }
  }
}

export default documentTemplates
